export default __webpack_public_path__ + "static/media/psDetail.9e62cae0.png";